import { render, staticRenderFns } from "./headernew.vue?vue&type=template&id=3cbce52c&"
import script from "./headernew.vue?vue&type=script&lang=js&"
export * from "./headernew.vue?vue&type=script&lang=js&"
import style0 from "./headernew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./headernew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports